export default __webpack_public_path__ + "static/media/hyrda-observation.0f4bf213.jpg";